// @flow
import React from 'react';
import { Modal, Button } from 'semantic-grab-ui/src';

type Props = {
  header: string,
  content: string,
  onConfirmation: Function,
  onClose: Function,
  yesText: string,
  noText: string,
  yesStyle: string,
  noStyle: string,
  open: boolean,
};

export default class ConfirmationModal extends Modal {
  props: Props;

  render() {
    const { header, content, open, onConfirmation, onClose, yesText, noText, yesStyle, noStyle } = this.props;
    return (
      <Modal open={open} onClose={onClose}>
        <Modal.Header>
          {header}
        </Modal.Header>
        <Modal.Content>
          {content}
        </Modal.Content>
        <Modal.Actions>
          <Button className={noStyle || 'negative'} onClick={onClose}>
            {noText}
          </Button>
          <Button className={yesStyle || 'positive'} onClick={onConfirmation}>
            {yesText}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
